export const errorCodes = [
  'NON_LAST_COLLECTION_PACKAGING_UNIT_OF_HIERARCHY_CANNOT_BE_DELETED',
  'MULTIPLE_CHILDREN_OF_NON_UNIQUE_COLLECTION_PACKAGING_UNIT',
  'MAX_DEPTH_OF_COLLECTION_PACKAGING_UNIT_HIERARCHY_REACHED',
  'DUPLICATE',
  'DUPLICATE_BY_EAN',
  'SORTIMENT_DUPLICATE',
  'FILE_UPLOAD_ERROR',
  'INVALID_FILE_EXTENSION',
  'IMAGE_LIMIT_REACHED',
  'DEFAULT_IMAGE_NOT_DELETABLE',
  'INVALID_STATEMENT_STATUS',
  'INVALID_STATUS_CHANGE',
  'ACCEPTANCE_PERIOD_HAS_EXPIRED',
  'ZERO_VAT_CAN_NOT_BE_ADDED_TO_SORTIMENT',
  'INVALID_PRODUCT_TRANSFER_REQUEST',
  'DUPLICATED_PRODUCT_TRANSFER_REQUEST',
  'PRODUCT_TRANSFER_REQUEST_CONFLICT',
  'INVALID_PRODUCT_TRANSFER_REQUEST_STATUS',
  'SITE_CANNOT_BE_DELETED',
  'NO_VALID_MERCHANT_TYPE',
  'DUPLICATED_DISCOUNT_CREATION_REQUEST',
  'APPROVE_FAILED_NO_VALID_MERCHANT_TYPE',
  'EMAIL_AREADY_USED',
  'RETAILERS_CAN_CREATE_ONLY_SECONDARY_PRODUCT_SHEETS',
];
